export enum NodeType {
    article = 'article',
    subFolder = 'sub_folder',
    url = 'url',
}

export interface ResourceNode {
    parent?: string;
    id: string;
    name: string;
    description: string;
    download_url?: string;
    thumbnail: string;
    date: Date | undefined;
    public: boolean;
    type: string;
    organizations?: string[];
    content?: string;
    node_type?: string;
    order?: number;
    is_system_resource?: boolean;
}

export interface ListNodesFilter {
    organizations?: number[];
    systemResource?: boolean;

    parentId?: string;
    public?: boolean;
}
